import React, { Component, Fragment } from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import SweetAlert from 'react-bootstrap-sweetalert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import api from '../../services/api';

import { Container, Filter } from './styles';

import Input from '../../components/Input';
import Select from '../../components/Select';
import Loading from '../../components/Loading';

export default class MyEvents extends Component {
  state = {
    alert: {},
    events: [],
    filterOption: 'active',
    loading: true,
    searchResults: [],
    searchInput: '',
    showAlert: false,
  };

  filterOptions = [
    { value: 'active', text: 'Em andamento' },
    { value: 'finished', text: 'Finalizada' },
    { value: 'pending_evaluation', text: 'Avaliação pendente' },
    { value: 'all', text: 'Todos' },
  ];

  componentDidMount() {
    this.loadEvents();
  }

  loadEvents = async () => {
    try {
      const { data } = await api.get('events', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_producer')}`,
        },
      });

      const formated = data.events.map(event => ({
        ...event,
        start_at: moment(event.start_at).format('DD/MM/YYYY'),
        end_at: moment(event.end_at).format('DD/MM/YYYY'),
        last_post_date: event.last_post_date
          ? moment(event.last_post_date).format('DD/MM/YYYY, HH:mm[h]')
          : null,
      }));

      this.setState({
        events: formated,
      });

      this.setState({ loading: false });
    } catch (err) {
      this.setState({ loading: false });
      const messages = err.response && err.response.data && err.response.data.errors
        ? err.response.data.errors
        : ['Não foi possível completar a requisição. Por favor, atualize a página.'];
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages,
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    }
  };

  handleSearch = (e) => {
    const { events } = this.state;
    this.setState({ searchInput: e.target.value }, () => {
      const { searchInput } = this.state;
      this.setState({
        searchResults: events.filter(event =>
          event.name.toLowerCase().includes(searchInput.toLowerCase())),
      });
    });
  };

  handleFilter = (e) => {
    this.setState({ filterOption: e.target.value });
  };

  openAlert = () => {
    this.setState({
      showAlert: true,
    });
  };

  closeAlert = () => {
    this.setState({
      showAlert: false,
    });
  };

  render() {
    const {
      alert: {
        cancelBtnText,
        cancelBtnBsStyle,
        confirmBtnText,
        confirmBtnBsStyle,
        messages,
        onConfirm,
        showCancel,
        title,
        type,
      },
      events,
      filterOption,
      loading,
      searchInput,
      searchResults,
      showAlert,
    } = this.state;
    let filtered_events = searchInput.length > 0 ? searchResults : events;
    if (filterOption !== 'all') {
      filtered_events = filtered_events.filter(
        event => event.status === filterOption,
      );
    }
    return (
      <Container>
        {loading ? (
          <Loading />
        ) : (
          <div>
            <h1 className="page-title">Meus eventos</h1>
            <div className="box">
              {this.state.events.length !== 0 && (
                <div className="box-header">
                  <Input
                    className="search-input"
                    name="searchInput"
                    onChange={this.handleSearch}
                    placeholder="Buscar evento"
                    value={searchInput}
                  />
                  <Filter>
                    <span>Status da divulgação:</span>
                    <Select
                      onChange={this.handleFilter}
                      options={this.filterOptions}
                      value={filterOption}
                    />
                  </Filter>
                </div>
              )}
              {events.length !== 0 ? (
                <Fragment>
                  {filtered_events.length > 0 ? (
                    <div className="cards-grid">
                      {filtered_events.map(event => (
                        <div key={event.id} className="card card-small">
                          <Link
                            className="wrapper-link"
                            to={`/panel/events/${event.id}`}
                          >
                            <div
                              className="card-image"
                              style={{
                                backgroundImage: `url(${event.cover})`,
                              }}
                            >
                              {event.approval_status !== 'approved' && (
                                <div className="card-label">{event.approval_status_i18n}</div>
                              )}
                            </div>
                            <div className="card-block">
                              <h4 className="card-title">{event.name}</h4>
                              <p className="card-text">
                                <strong>Início da divulgação: </strong>
                                <br />
                                {event.start_at}
                              </p>
                              <p className="card-text">
                                <strong>Fim da divulgação: </strong>
                                <br />
                                {event.end_at}
                              </p>
                              <p className="card-text">
                                {event.last_post_date ? (
                                  <Fragment>
                                    <strong>Última publicação: </strong>
                                    <br />
                                    {event.last_post_date}
                                  </Fragment>
                                ) : (
                                  <strong>Não possui publicações</strong>
                                )}
                              </p>
                              <p className="card-text">
                                <strong>Divulgadores ativos: </strong>
                                {event.active_promoters}
                              </p>
                            </div>
                          </Link>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <Fragment>
                      <h5 className="text-center">
                        Nenhum evento encontrado.
                      </h5>
                    </Fragment>
                  )}
                </Fragment>
              ) : (
                <h5 className="text-center">
                  Você ainda não criou nenhum evento.
                </h5>
              )}
            </div>
            <Link
              to="/panel/create-event"
              className="btn btn-success btn-add btn-fixed"
            >
              <FontAwesomeIcon icon={faPlus} />
            </Link>
          </div>
        )}
        {showAlert && (
          <SweetAlert
            type={type}
            confirmBtnText={confirmBtnText}
            confirmBtnBsStyle={confirmBtnBsStyle}
            showCancel={showCancel}
            cancelBtnText={cancelBtnText}
            cancelBtnBsStyle={cancelBtnBsStyle}
            title={title}
            onConfirm={onConfirm}
            onCancel={this.closeAlert}
          >
            <ul>
              {messages.map(msg => (
                <li key={msg}>{msg}</li>
              ))}
            </ul>
          </SweetAlert>
        )}
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/MyEvents/index.js